/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

export default function AppPolicy() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row">
      <div className="w-full flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-12 ">
        <h2 className="text-5xl text-theme-blue text-center font-bold leading-tight mb-4 dark:text-white">
          Nube iO App Policy
        </h2>
        <div className="my-6 w-full border-t-4 border-theme-teal mb-12 " />
        <div className="space-y-6">
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Last updated October 17, 2022
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            This privacy notice for Nube iO Pty Ltd (“Company”, “we”, “us”, or
            “our”), describes how and why we might collect, store, use, and/or
            share (“process”) your information when you use our services
            (“Services”), such as when you:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              Download and use our mobile application (DASH iO) , or any other
              application of ours that links to this privacy notice
            </li>
            <li>
              Engage with us in other related ways, including any sales,
              marketing, or events
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Questions or concerns? Reading this privacy notice will help you
            understand your privacy rights and choices. If you do not agree with
            our policies and practices, please do not use our Services. If you
            still have any questions or concerns, please contact us at{" "}
            <a href="mailto:info@nube-io.com">info@nube-io.com</a>.
          </p>
          <h4 className="text-xl font-bold text-theme-teal">
            SUMMARY OF KEY POINTS
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            This summary provides key points from our privacy notice, but you
            can find out more details about any of these topics by clicking the
            link following each key point or by using our table of contents
            below to find the section you are looking for. You can also click
            here to go directly to our table of contents.
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              <strong>What personal information do we process?</strong> When you
              visit, use, or navigate our Services, we may process personal
              information depending on how you interact with Nube iO Pty Ltd and
              the Services, the choices you make, and the products and features
              you use. Click here to learn more
            </li>
            <li>
              <strong>Do we process any sensitive personal information?</strong>{" "}
              We do not process sensitive personal information.
            </li>
            <li>
              <strong>Do we receive any information from third parties?</strong>{" "}
              We do not receive any information from third parties.
            </li>
            <li>
              <strong>How do we process your information?</strong> We process
              your information to provide, improve, and administer our Services,
              communicate with you, for security and fraud prevention, and to
              comply with law. We may also process your information for other
              purposes with your consent. We process your information only when
              we have a valid legal reason to do so.{" "}
              <strong>Click here to learn more.</strong>
            </li>
            <li>
              <strong>
                In what situations and with which parties do we share personal
                information?
              </strong>{" "}
              We may share information in specific situations and with specific
              third parties. Click here to learn more.
            </li>
            <li>
              <strong>How do we keep your information safe?</strong> We have
              organizational and technical processes and procedures in place to
              protect your personal information. However, no electronic
              transmission over the internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other unauthorized
              third parties will not be able to defeat our security and
              improperly collect, access, steal, or modify your information.
              Click here to learn more.
            </li>
            <li>
              <strong>What are your rights?</strong> Depending on where you are
              located geographically, the applicable privacy law may mean you
              have certain rights regarding your personal information.Click here
              to learn more.
            </li>
            <li>
              <strong>How do you exercise your rights?</strong> The easiest way
              to exercise your rights is by filling out our data subject request
              form available here:{" "}
              <a href="https://nube-io.com/contact/">
                https://nube-io.com/contact/
              </a>
              , or by contacting us. We will consider and act upon any request
              in accordance with applicable data protection laws.
            </li>
            <li>
              <strong>
                Want to learn more about what Nube iO Pty Ltd does with any
                information we collect?
              </strong>{" "}
              Click here to review the notice in full.
            </li>
          </ul>
          <h4 className="text-xl font-bold text-theme-teal ">
            TABLE OF CONTENTS
          </h4>
          <ol className="list-decimal list-inside pl-6 text-base font-light text-gray-400 mb-6">
            <li>What information do we collect?</li>
            <li>How do we process your information?</li>
            <li>
              What legal bases do we rely on to process your personal
              information?
            </li>
            <li>When and whom do we share your personal information?</li>
            <li>How long do we keep your information?</li>
            <li>How do we keep your personal information safe?</li>
            <li>Do we collect information from miners?</li>
            <li>What are your privacy rights</li>
            <li>Controls for do-not-track features?</li>
            <li>Do California residents have specific privacy rights?</li>
            <li>Do we make updates to this notice?</li>
            <li>How can you contact us about this notice?</li>
            <li>
              How can you review, update, or delete the data we collect from
              you?
            </li>
          </ol>
          <h4 className="text-xl font-bold text-theme-teal">
            1. WHAT INFORMATION DO WE COLLECT?
          </h4>
          <h3 className="text-lg font-bold text-theme-teal">
            Personal information you disclose to us.
          </h3>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We collect personal information that you provide to us.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We collect personal information that you voluntarily provide to us
            when you register on the Services, express an interest in obtaining
            information about us or our products and Services, when you
            participate in activities on the Services, or otherwise when you
            contact us.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Personal Information Provided by You. The personal information that
            we collect depends on the context of your interactions with us and
            the Services, the choices you make, and the products and features
            you use. The personal information we collect may include the
            following:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>Contact Preferences</li>
            <li>Job Titles</li>
            <li>Names</li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Sensitive Information. We do not process sensitive information.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Application Data. If you use our application(s), we also may collect
            the following information if you choose to provide us with access or
            permission:
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Mobile Device Access. We may request access or permission to certain
            features from your mobile device, including your mobile device’s
            reminders, storage, social media accounts, nfc, and other features.
            If you wish to change our access or permissions, you may do so in
            your device’s settings.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Push Notifications. We may requesto send you push notifications
            regarding your account or certain features of the application(s). If
            you wish to opt out from receiving these types of communications,
            you may turn them off in your device’s settings.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            This information is primarily needed to maintain the security and
            operation of our application(s), for troubleshooting, and for our
            internal analytics and reporting purposes.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            All personal information that you provide to us must be true,
            complete, and accurate, and you must notify us of any changes to
            such personal information.
          </p>
          <h4 className="text-lg font-semibold text-theme-teal ">
            Information Automatically Collected
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: Some information — such as your Internet Protocol (IP)
            address and/or browser and device characteristics — is collected
            automatically when you visit our Services.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We automatically collect certain information when you visit, use, or
            navigate the Services. This information does not reveal your
            specific identity (like your name or contact information) but may
            include device and usage information, such as your IP address,
            browser and device characteristics, operating system, language
            preferences, referring URLs, device name, country, location,
            information about how and when you use our Services, and other
            technical information. This information is primarily needed to
            maintain the security and operation of our Services, and for our
            internal analytics and reporting purposes.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            The information we collect includes:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              Device Data. We collect device data such as information about your
              computer, phone, tablet, or other device you use to access the
              Services. Depending on the device used, this device data may
              include information such as your IP address (or proxy server),
              device and application identification numbers, location, browser
              type, hardware model, Internet service provider and/or mobile
              carrier, operating system, and system configuration information.
            </li>
            <li>
              Device Data. We collect device data such as information about your
              computer, phone, tablet, or other device you use to access the
              Services. Depending on the device used, this device data may
              include information such as your IP address (or proxy server),
              device and application identification numbers, location, browser
              type, hardware model, Internet service provider and/or mobile
              carrier, operating system, and system configuration information.
            </li>
          </ul>
          <h4 className="text-xl font-semibold text-theme-teal ">
            2. HOW DO WE PROCESS YOUR INFORMATION?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We process your information to provide, improve, and
            administer our Services, communicate with you, for security and
            fraud prevention, and to comply with law. We may also process your
            information for other purposes with your consent.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We process your personal information for a variety of reasons,
            depending on how you interact with our Services, including:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              To facilitate account creation and authentication and otherwise
              manage user accounts. We may process your information so you can
              create and log in to your account, as well as keep your account in
              working order.
            </li>
            <li>
              To save or protect an individual’s vital interest. We may process
              your information when necessary to save or protect an individual’s
              vital interest, such as to prevent harm.
            </li>
          </ul>
          <h4 className="text-xl font-semibold text-theme-teal ">
            3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We only process your personal information when we believe
            it is necessary and we hasve a valid legal reason (i.e. , legal
            basis) to do so under applicable law, like with your consent, to
            comply with laws, to provide you with services to enter into or
            fulfill our contractual obligations, to protect your rights, or to
            fulfill our legitimate business interests.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you are located in the EU or UK, this section applies to you.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            The General Data Protection Regulation (GDPR) and UK GDPR require us
            to explain the valid legal bases we rely on in order to process your
            personal information. As such, we may rely on the following legal
            bases to process your personal information:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              Consent. We may process your information if you have given us
              permission (i.e. , consent) to use your personal information for a
              specific purpose. You can withdraw your consent at any time. Click
              here to learn more.
            </li>
            <li>
              Legal Obligations. We may process your information where we
              believe it is necessary for compliance with our legal obligations,
              such as to cooperate with a law enforcement body or regulatory
              agency, exercise or defend our legal rights, or disclose your
              information as evidence in litigation in which we are involved.
            </li>
            <li>
              Vital Interests. We may process your information where we believe
              it is necessary to protect your vital interests or the vital
              interests of a third party, such as situations involving potential
              threats to the safety of any person.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you are located in Canada, this section applies to you.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may process your information if you have given us specific
            permission (i.e. , express consent) to use your personal information
            for a specific purpose, or in situations where your permission can
            be inferred (i.e. , implied consent). You can withdraw your consent
            at any time. Click here to learn more.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In some exceptional cases, we may be legally permitted under
            applicable law to process your information without your consent,
            including, for example:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              If collection is clearly in the interests of an individual and
              consent cannot be obtained in a timely way.
            </li>
            <li>For investigations and fraud detection and prevention.</li>
            <li>
              For business transactions provided certain conditions are met.
            </li>
            <li>
              If it is contained in a witness statement and the collection is
              necessary to assess, process, or settle an insurance claim.
            </li>
            <li>
              For identifying injured, ill, or deceased persons and
              communicating with next of kin.
            </li>
            <li>
              If we have reasonable grounds to believe an individual has been,
              is, or may be victim of financial abuse.
            </li>
            <li>
              If it is reasonable to expect collection and use with consent
              would compromise the availability or the accuracy of the
              information and the collection is reasonable for purposes related
              to investigating a breach of an agreement or a contravention of
              the laws of Canada or a province.
            </li>
            <li>
              If disclosure is required to comply with a subpoena, warrant,
              court order, or rules of the court relating to the production of
              records.
            </li>
            <li>
              If it was produced by an individual in the course of their
              employment, business, or profession and the collection is
              consistent with the purposes for which the information was
              produced.
            </li>
            <li>
              If the collection is solely for journalistic, artistic, or
              literary purposes.
            </li>
            <li>
              If the information is publicly available and is specified by the
              regulations.
            </li>
          </ul>
          <h4 className="text-xl font-semibold text-theme-teal">
            4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We may share information in specific situations described
            in this section and/or with the following third parties.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may need to share your personal information in the following
            situations:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              Business Transfers. We may share or transfer your information in
              connection with, or during negotiations of, any merger, sale of
              company assets, financing, or acquisition of all or a portion of
              our business to another company.
            </li>
          </ul>
          <h4 className="text-xl font-semibold text-theme-teal">
            5. HOW LONG DO WE KEEP YOUR INFORMATION?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We keep your information for as long as necessary to
            fulfill the purposes outlined in this privacy notice unless
            otherwise required by law.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We will only keep your personal information for as long as it is
            necessary for the purposes set out in this privacy notice, unless a
            longer retention period is required or permitted by law (such as
            tax, accounting, or other legal requirements). No purpose in this
            notice will require us keeping your personal information for longer
            than the period of time in which users have an account with us
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            When we have no ongoing legitimate business need to process your
            personal information, we will either delete or anonymize such
            information, or, if this is not possible (for example, because your
            personal information has been stored in backup archives), then we
            will securely store your personal information and isolate it from
            any further processing until deletion is possible.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal ">
            6. HOW DO WE KEEP YOUR INFORMATION SAFE?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We aim to protect your personal information through a
            system of organizational and technical security measures.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We have implemented appropriate and reasonable technical and
            organizational security measures designed to protect the security of
            any personal information we process. However, despite our safeguards
            and efforts to secure your information, no electronic transmission
            over the Internet or information storage technology can be
            guaranteed to be 100% secure, so we cannot promise or guarantee that
            hackers, cybercriminals, or other unauthorized third parties will
            not be able to defeat our security and improperly collect, access,
            steal, or modify your information. Although we will do our best to
            protect your personal information, transmission of personal
            information to and from our Services is at your own risk. You should
            only access the Services within a secure environment.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Other privacy rights:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              You may object to the processing of your personal information.
            </li>
            <li>
              You may request correction of your personal data if it is
              incorrect or no longer relevant, or ask to restrict the processing
              of the information.
            </li>
            <li>
              You can designate an authorized agent to make a request under the
              CCPA on your behalf. We may deny a request from an authorized
              agent that does not submit proof that they have been validly
              authorized to act on your behalf in accordance with the CCPA.
            </li>
            <li>
              You may request to opt out from future selling of your personal
              information to third parties. Upon receiving an opt-out request,
              we will act upon the request as soon as feasibly possible, but no
              later than fifteen (15) days from the date of the request
              submission.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            To exercise these rights, you can contact us by email at{" "}
            <a href="mailto:info@nube-io.com">info@nube-io.com</a>, 1/17
            Cemetery Rd Helensburgh, NSW 2508, Australia, or by referring to the
            contact details at the bottom of this document, If you have a
            complaint about how we handle your data, we would like to hear from
            you.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal">
            7. DO WE COLLECT INFORMATION FROM MINORS?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: We do not knowingly collect data from or market to
            children under 18 years of age.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We do not knowingly solicit data from or market to children under 18
            years of age. By using the Services, you represent that you are at
            least 18 or that you are the parent or guardian of such a minor and
            consent to such minor dependent’s use of the Services. If we learn
            that personal information from users less than 18 years of age has
            been collected, we will deactivate the account and take reasonable
            measures to promptly delete such data from our records. If you
            become aware of any data we may have collected from children under
            age 18, please contact us at{" "}
            <a href="mailto:info@nube-io.com">info@nube-io.com</a>.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal">
            8. WHAT ARE YOUR PRIVACY RIGHTS?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: In some regions, such as the European Economic Area (EEA),
            United Kingdom (UK), and Canada , you have rights that allow you
            greater access to and control over your personal information. You
            may review, change, or terminate your account at any time.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In some regions (like the EEA, UK, and Canada ), you have certain
            rights under applicable data protection laws. These may include the
            right (i) to request access and obtain a copy of your personal
            information, (ii) to request rectification or erasure; (iii) to
            restrict the processing of your personal information; and (iv) if
            applicable, to data portability. In certain circumstances, you may
            also have the right to object to the processing of your personal
            information. You can make such a request by contacting us by using
            the contact details provided in the section ” HOW CAN YOU CONTACT US
            ABOUT THIS NOTICE? ” below.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We will consider and act upon any request in accordance with
            applicable data protection laws.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you are located in the EEA or UK and you believe we are
            unlawfully processing your personal information, you also have the
            right to complain to your local data protection supervisory
            authority. You can find their contact details here:{" "}
            <a href="https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">
              https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
            </a>
            .
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you are located in Switzerland, the contact details for the data
            protection authorities are available here:{" "}
            <a href="https://www.edoeb.admin.ch/edoeb/en/home.html">
              https://www.edoeb.admin.ch/edoeb/en/home.html
            </a>
            .
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Withdrawing your consent: If we are relying on your consent to
            process your personal information, which may be express and/or
            implied consent depending on the applicable law, you have the right
            to withdraw your consent at any time. You can withdraw your consent
            at any time by contacting us by using the contact details provided
            in the section ” HOW CAN YOU CONTACT US ABOUT THIS NOTICE? ” below .
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            However, please note that this will not affect the lawfulness of the
            processing before its withdrawal nor, when applicable law allows,
            will it affect the processing of your personal information conducted
            in reliance on lawful processing grounds other than consent.
          </p>
          <h4 className="text-lg font-semibold text-theme-teal ">
            Account Information
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you would at any time like to review or change the information in
            your account or terminate your account, you can:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              Log in to your account settings and update your user account.
            </li>
            <li>Contact us using the contact information provided.</li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Upon your request to terminate your account, we will deactivate or
            delete your account and information from our active databases.
            However, we may retain some information in our files to prevent
            fraud, troubleshoot problems, assist with any investigations,
            enforce our legal terms and/or comply with applicable legal
            requirements.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you have questions or comments about your privacy rights, you may
            email us at <a href="mailto:info@nube-io.com">info@nube-io.com</a>.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal ">
            9. CONTROLS FOR DO-NOT-TRACK FEATURES
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Most web browsers and some mobile operating systems and mobile
            applications include a Do-Not-Track ( “DNT” ) feature or setting you
            can activate to signal your privacy preference not to have data
            about your online browsing activities monitored and collected. At
            this stage no uniform technology standard for recognizing and
            implementing DNT signals has been finalized . As such, we do not
            currently respond to DNT browser signals or any other mechanism that
            automatically communicates your choice not to be tracked online. If
            a standard for online tracking is adopted that we must follow in the
            future, we will inform you about that practice in a revised version
            of this privacy notice.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal ">
            10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: Yes, if you are a resident of California, you are granted
            specific rights regarding access to your personal information.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            California Civil Code Section 1798.83, also known as the “Shine The
            Light” law, permits our users who are California residents to
            request and obtain from us, once a year and free of charge,
            information about categories of personal information (if any) we
            disclosed to third parties for direct marketing purposes and the
            names and addresses of all third parties with which we shared
            personal information in the immediately preceding calendar year. If
            you are a California resident and would like to make such a request,
            please submit your request in writing to us using the contact
            information provided below.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you are under 18 years of age, reside in California, and have a
            registered account with Services, you have the right to request
            removal of unwanted data that you publicly post on the Services. To
            request removal of such data, please contact us using the contact
            information provided below and include the email address associated
            with your account and a statement that you reside in California. We
            will make sure the data is not publicly displayed on the Services,
            but please be aware that the data may not be completely or
            comprehensively removed from all our systems (e.g. , backups, etc.).
          </p>
          <h4 className="text-lg font-semibold text-theme-teal ">
            CCPA Privacy Notice
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            The California Code of Regulations defines a “resident” as:
          </p>
          <ol className="list-decimal list-inside pl-6 text-base font-light text-gray-400 mb-6">
            <li>
              (1) every individual who is in the State of California for other
              than a temporary or transitory purpose and
            </li>
            <li>
              (2) every individual who is domiciled in the State of California
              who is outside the State of California for a temporary or
              transitory purpose
            </li>
          </ol>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            All other individuals are defined as “non-residents.”
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If this definition of “resident” applies to you, we must adhere to
            certain rights and obligations regarding your personal information.
          </p>
          <h4 className="text-lg font-semibold text-theme-teal ">
            What categories of personal information do we collect?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We have collected the following categories of personal information
            in the past twelve (12) months:
          </p>
          <table className="mi-tabla">
            <thead className="bg-gray-50 dark:bg-gray-600">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white"
                >
                  Category
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white"
                >
                  Examples
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white"
                >
                  Collected
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-600">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  A. Identifiers
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Contact details, such as real name, alias, postal address,
                  telephone or mobile contact number, unique personal
                  identifier, online identifier, Internet Protocol address,
                  email address and account name.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  YES
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  B. Personal information categories listed in the California
                  Customer Records statute.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Name, contact information, education, employment history, and
                  financial information.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  C. Protected classification characteristics under California
                  or federal law
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Gender and date of birth.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  D. Commercial information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Transaction information, purchase history, financial details,
                  and payment information.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  E. Biometric information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Fingerprints and voiceprints.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  F. Internet or other similar network activity
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Browsing history, search history, online behavior , interest
                  data, and interactions with our and other websites,
                  applications, systems, and advertisements.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  G. Geolocation data
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Device location
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  H. Audio, electronic, visual, thermal, olfactory, or similar
                  information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Images and audio, video or call recordings created in
                  connection with our business activities.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  I. Professional or employment-related information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Business contact details in order to provide you our Services
                  at a business level or job title, work history, and
                  professional qualifications if you apply for a job with us.
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  J. Education Information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Student records and directory information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  K. Inferences drawn from other personal information
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  Inferences drawn from any of the collected personal
                  information listed above to create a profile or summary about,
                  for example, an individual’s preferences and characteristics
                </td>
                <td className="px-6 py-4 whitespace-nowrap dark:text-white">
                  NO
                </td>
              </tr>
            </tbody>
          </table>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may also collect other personal information outside of these
            categories through instances where you interact with us in person,
            online, or by phone or mail in the context of:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>Receiving help through our customer support channels;</li>
            <li>Participation in customer surveys or contests; and</li>
            <li>
              Facilitation in the delivery of our Services and to respond to you
              inquiries.
            </li>
          </ul>
          <h4 className="text-lg font-semibold text-theme-teal">
            How do we use and share your personal information?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            More information about our data collection and sharing practices can
            be found in this privacy notice.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            You may contact us by email at{" "}
            <a href="mailto:info@nube-io.com">info@nube-io.com</a>, 1/17
            Cemetery Rd Helensburgh, NSW 2508, Australia, or by referring to the
            contact details at the bottom of this document.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you are using an authorized agent to exercise your right to opt
            out we may deny a request if the authorized agent does not submit
            proof that they have been validly authorized to act on your behalf.
          </p>
          <h3 className="text-lg font-semibold text-theme-teal ">
            Will your information be shared with anyone else?
          </h3>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may disclose your personal information with our service providers
            pursuant to a written contract between us and each service provider.
            Each service provider is a for-profit entity that processes the
            information on our behalf.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may use your personal information for our own business purposes,
            such as for undertaking internal research for technological
            development and demonstration. This is not considered to be
            “selling” of your personal information.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO Pty Ltd has not disclosed or sold any personal information
            to third parties for a business or commercial purpose in the
            preceding twelve (12) months. Nube iO Pty Ltd will not sell personal
            information in the future belonging to website visitors, users, and
            other consumers.
          </p>
          <h3 className="text-lg font-semibold text-theme-teal ">
            Your rights with respect to your personal data.
          </h3>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may disclose your personal information with our service providers
            pursuant to a written contract between us and each service provider.
            Each service provider is a for-profit entity that processes the
            information on our behalf.
          </p>
          <h4 className="text-md font-semibold text-theme-teal ">
            Rights to be informed – Request to know.
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Depending on the circumstances, you have a right to know:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>Whether we collect and use your personal information;</li>
            <li>The categories of personal information that we collect;</li>
            <li>
              The purposes for which the collected personal information is used;
            </li>
            <li>Whether we sell your personal information to third parties;</li>
            <li>
              The categories of personal information that we sold or disclosed
              for a business purpose;
            </li>
            <li>
              The categories of third parties to whom the personal information
              was sold or disclosed for a business purpose; and
            </li>
            <li>
              The business or commercial purpose for collecting or selling
              personal information.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In accordance with applicable law, we are not obligated to provide
            or delete consumer information that is de-identified in response to
            a consumer request or to re-identify individual data to verify a
            consumer request.
          </p>
          <h4 className="text-md font-semibold text-theme-teal ">
            Rights to be Non-Discrimination for the exercise of a Consumer’s
            Privacy Rights
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We will not discriminate against you if you exercise your privacy
            rights.
          </p>
          <h3 className="text-lg font-semibold text-theme-teal">
            Other privacy rights:
          </h3>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              You may object to the processing of your personal information.
            </li>
            <li>
              You may request correction of your personal data if it is
              incorrect or no longer relevant, or ask to restrict the processing
              of the information.
            </li>
            <li>
              You can designate an authorized agent to make a request under the
              CCPA on your behalf. We may deny a request from an authorized
              agent that does not submit proof that they have been validly
              authorized to act on your behalf in accordance with the CCPA.
            </li>
            <li>
              You may request to opt out from future selling of your personal
              information to third parties. Upon receiving an opt-out request,
              we will act upon the request as soon as feasibly possible, but no
              later than fifteen (15) days from the date of the request
              submission.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            To exercise these rights, you can contact us by email at{" "}
            <a href="mailto:info@nube-io.com">info@nube-io.com</a>, 1/17
            Cemetery Rd Helensburgh, NSW 2508, Australia, or by referring to the
            contact details at the bottom of this document, If you have a
            complaint about how we handle your data, we would like to hear from
            you.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal">
            11. DO WE MAKE UPDATES TO THIS NOTICE?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In Short: Yes, we will update this notice as necessary to stay
            compliant with relevant laws.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We may update this privacy notice from time to time. The updated
            version will be indicated by an updated “Revised” date and the
            updated version will be effective as soon as it is accessible. If we
            make material changes to this privacy notice, we may notify you
            either by prominently posting a notice of such changes or by
            directly sending you a notification. We encourage you to review this
            privacy notice frequently to be informed of how we are protecting
            your information.
          </p>
          <h4 className="text-xl font-semibold text-theme-teal">
            12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If you have questions or comments about this notice, you may email
            us at <a href="mailto:info@nube-io.com">info@nube-io.com</a> or by
            post to:
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO Pty Ltd
            <br />
            1/17 Cemetery Rd
            <br />
            Helensburgh, New South Wales 2508
            <br />
            Australia
          </p>
          <h4 className="text-xl font-semibold text-theme-teal ">
            13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
            YOU?
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed pb-16">
            Based on the applicable laws of your country, you may have the right
            to request access to the personal information we collect from you,
            change that information, or delete it. To request to review, update,
            or delete your personal information, please visit:{" "}
            <a
              href="https://nube-io.com/contact/"
              className="text-teal-700 font-bol "
            >
              https://nube-io.com/contact/
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
